/*
 *   File : custom-date-picker.jsx
 *   Author : https://evoqins.com
 *   Description : Custom date picker component
 *   Integrations : null
 *   Version : 1.0.0
*/

import { useEffect, useRef, useState } from "react";
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';
import { Icon } from "../Icon";
import { GradientButton } from "../Cta";

const format = 'HH:mm:ss';  //'hh:mm A'; (12 hr format)

function CustomTimePicker(props) {

    const timePickerRef = useRef(null);
    const [selectedTime, setSelectedTime] = useState(
        props.selectedTime ? moment(props.selectedTime, format) : undefined
    );
    const [showTimePicker, setShowTimePicker] = useState(false);

    useEffect(() => {
        if (showTimePicker) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [showTimePicker]);

    // keep internal state in sync with external selectedTime
    useEffect(() => {
        if (props.selectedTime) {
            setSelectedTime(moment(props.selectedTime, format));
        } else {
            setSelectedTime(undefined);
        }
    }, [props.selectedTime]);



    // handle time select
    const _handleTimeSelect = (time) => {
        if (timePickerRef.current) {
            timePickerRef.current.focus();
        }

        if (time) {
            // All minutes 0-59 are allowed (1-minute intervals)
            const updatedTime = time.clone().millisecond(0);
            setSelectedTime(updatedTime);
        } else {
            setSelectedTime(undefined);
        }
    };




    // handle confirm select
    const _handleSubmitSelected = (panel) => {
        if (selectedTime) {
            const formatted = selectedTime.format(format);
            props.handleSelectTime(formatted);
        } else {
            setSelectedTime(undefined);
            props.handleSelectTime("");
        }
        setShowTimePicker(false);
        panel.close();

        if (timePickerRef.current) {
            timePickerRef.current.blur();
        }
    };

    const _handleFocus = () => {
        setShowTimePicker(true);
    };

    return (
        <div className="position-relative  cursor-pointer">
            {/* <p className={`${props.error ? 'e-color-red' : 'e-text-black'} e-font-montserrat-arabic-light e-font-14 line-height-20px mb-1`}>
                {props.label}
            </p> */}

            <div className={`position-relative  border-radius-6px border-all d-flex align-items-center justify-content-between padding-12px-lr   border-bright-gray bg-white e-poppins-regular e-font-14 line-height-24px color-outer-space cursor-pointer`}
                onClick={() => timePickerRef.current && timePickerRef.current.focus()}>
                <TimePicker
                    ref={timePickerRef}
                    onOpen={_handleFocus}
                    onClose={() => setShowTimePicker(false)}
                    value={selectedTime}
                    showSecond={true}
                    focusOnOpen={false}
                    hideDisabledOptions={true}
                    disabledHours={props.disabledTime?.disabledHours}
                    disabledMinutes={props.disabledTime?.disabledMinutes}
                    name="time-picker"
                    placeholder={props.placeHolder}
                    inputReadOnly
                    className={`time-picker-input ${props.error ? "error" : ""}`}
                    use12Hours={false}
                    disabled={props.disabled}
                    getPopupContainer={props.getPopupContainer ? props.getPopupContainer : (trigger => trigger.parentNode)}
                    popupStyle={{ zIndex: 2000 }}
                    addon={(panel) => (
                        <GradientButton label="Select"
                            className=" e-time-picker-button"
                            onPress={() =>  _handleSubmitSelected(panel) }
                        />
                    )}
                    placement={props.placement ? props.placement : "bottomLeft"}
                    inputIcon={null}
                    clearIcon={<span></span>}
                    onChange={_handleTimeSelect}
                />

                <span className={`position-absolute end-0 me-3 ${props.disabled ? "" : "cursor-pointer"}`}>
                    <Icon icon="time-picker" width="24px" height="24px" className={''} />
                </span>
            </div>

            {/* Error */}
            <p className="position-absolute top-100 e-font-montserrat-arabic-light e-font-8 e-color-red mb-0 mt-1">
                {props.error}
            </p>
        </div>
    );
}

export default CustomTimePicker;